import type { BuylistResponse, ListItemRef, SharedBuylistResponse, ShareTokenResponse } from '@/types'
import { request } from './client'

export async function getBuylist(): Promise<BuylistResponse> {
  return request<BuylistResponse>('/buylist')
}

export async function addToBuylist(cardId: number, quantity?: number, idempotencyKey?: string): Promise<ListItemRef> {
  const body: Record<string, unknown> = { cardId }
  if (quantity !== undefined) body.quantity = quantity
  const response = await request<{ buylistItem: ListItemRef }>('/buylist', {
    method: 'POST',
    body,
    idempotencyKey,
  })
  return response.buylistItem
}

export async function removeFromBuylist(cardId: number, idempotencyKey?: string, all?: boolean): Promise<void> {
  const query = all ? '?all=true' : ''
  await request<void>(`/buylist/card/${cardId}${query}`, { method: 'DELETE', idempotencyKey })
}

export async function bulkRemoveFromBuylist(
  cardIds: number[],
  idempotencyKey?: string,
): Promise<{ removedCount: number }> {
  return request<{ removedCount: number }>('/buylist/bulk', {
    method: 'DELETE',
    body: { cardIds },
    idempotencyKey,
  })
}

export async function getBuylistShareToken(): Promise<ShareTokenResponse> {
  return request<ShareTokenResponse>('/buylist/share_token')
}

export async function regenerateBuylistShareToken(idempotencyKey?: string): Promise<ShareTokenResponse> {
  return request<ShareTokenResponse>('/buylist/regenerate_token', { method: 'POST', idempotencyKey })
}

export async function getSharedBuylist(shareToken: string): Promise<SharedBuylistResponse> {
  return request<SharedBuylistResponse>(`/shared/buylist/${shareToken}`)
}
